import React from "react";
import {Helmet} from "react-helmet";

const Meta = ({title, desc, keywords = '', secondaryKeywords = '', h1, img}) => {

    return <>
        <Helmet>
            <meta charSet="utf-8" />
            <title>{title}</title>
            <meta name="description" content={desc} />
            <meta name="keywords" content={keywords} />
            <meta name="keywords" content={secondaryKeywords} />
            <meta property="og:title" content={title} />
            <meta property="og:site_name" content="Academons"/>
            <meta property="og:description" content={desc} />
            <meta name="twitter:image" content={img} />
            <meta property="og:image" itemProp="image" content={img} />
        </Helmet>
        <h1 style={{display: "none"}}>{h1}</h1>
    </>
}

export default Meta;